import React, { useState, useEffect } from "react";

import Languages from "../../../../translations";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import LockIcon from "@mui/icons-material/Lock";

const LeopsParentsHeard = ({
  supportPlanModel,
  generalPart,
  parentId,
  formLocked,
  onSave,
}) => {
  const SubModel = supportPlanModel;
  const isParent1 = parentId === generalPart?.Parent1Id;
  const isParent2 = parentId === generalPart?.Parent2Id;

  const [expanded, setExpanded] = useState(false);
  const [FormLocked, setFormLocked] = useState(SubModel?.Locked);
  const [Parent1Checked, setParent1Checked] = useState(SubModel?.HearedParent1);
  const [Parent2Checked, setParent2Checked] = useState(SubModel?.HearedParent2);
  const [parent1ApprovalText, setParent1ApprovalText] = useState(
    SubModel?.HearedParent1Approval ?? "",
  );
  const [parent2ApprovalText, setParent2ApprovalText] = useState(
    SubModel?.HearedParent2Approval ?? "",
  );

  useEffect(() => {
    if (!SubModel) return;
    setParent1Checked(SubModel.HearedParent1);
    setParent2Checked(SubModel.HearedParent2);
    setParent1ApprovalText(SubModel.HearedParent1Approval ?? "");
    setParent2ApprovalText(SubModel.HearedParent2Approval ?? "");
    setFormLocked(SubModel.Locked);
  }, [SubModel]);

  if (!SubModel || !generalPart) return null;

  return (
    <Accordion
      className="painikkeet"
      style={{ backgroundColor: "#4377BA" }}
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography className="heading">
          {Languages.ParentalHearing}
          {FormLocked && (
            <LockIcon style={{ color: "#D500F9" }} fontSize="large" />
          )}
        </Typography>
      </AccordionSummary>
      <div style={{ backgroundColor: "#ffffff", color: "black" }}>
        <AccordionDetails>
          <h5>{Languages.ParentalHearing2}</h5>
        </AccordionDetails>

        <AccordionDetails>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{ borderBottom: "none", color: "black" }}
                  align="left"
                >
                  {Languages.guardian + " 1"}
                </TableCell>
                <TableCell
                  sx={{ borderBottom: "none", pl: "20px", color: "black" }}
                  align="left"
                >
                  {Languages.guardian + " 2"}
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <TableCell
                  sx={{ borderBottom: "none", color: "black" }}
                  align="left"
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <input
                      type="checkbox"
                      style={{ width: "20px", height: "20px" }}
                      checked={Parent1Checked}
                      disabled={
                        !isParent1 ||
                        !SubModel.HearedParent1Editable ||
                        formLocked ||
                        SubModel.HearedParent1
                      }
                      onChange={() => setParent1Checked(!Parent1Checked)}
                    />
                    {generalPart.Parent1Name}
                  </span>
                </TableCell>

                <TableCell
                  sx={{ borderBottom: "none", pl: "20px", color: "black" }}
                  align="left"
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    {generalPart.Parent2Name && (
                      <input
                        type="checkbox"
                        style={{ width: "20px", height: "20px" }}
                        checked={Parent2Checked}
                        disabled={
                          !isParent2 ||
                          !SubModel.HearedParent2Editable ||
                          formLocked ||
                          SubModel.HearedParent2
                        }
                        onChange={() => setParent2Checked(!Parent2Checked)}
                      />
                    )}
                    {generalPart.Parent2Name ?? ""}
                  </span>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  sx={{ borderBottom: "none" }}
                  padding="none"
                  align="left"
                >
                  <textarea
                    value={parent1ApprovalText}
                    onChange={(e) => setParent1ApprovalText(e.target.value)}
                    disabled={
                      !isParent1 ||
                      !SubModel.HearedParent1Editable ||
                      formLocked ||
                      SubModel.HearedParent1
                    }
                    rows={3}
                    style={{ width: "100%", resize: "vertical" }}
                  />
                </TableCell>

                <TableCell
                  sx={{ borderBottom: "none", pl: "20px" }}
                  align="left"
                >
                  {generalPart.Parent2Name && (
                    <textarea
                      value={parent2ApprovalText}
                      onChange={(e) => setParent2ApprovalText(e.target.value)}
                      disabled={
                        !isParent2 ||
                        !SubModel.HearedParent2Editable ||
                        formLocked ||
                        SubModel.HearedParent2
                      }
                      rows={3}
                      style={{ width: "100%", resize: "vertical" }}
                    />
                  )}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={{ borderBottom: "none" }} align="left">
                  {isParent1 && Parent1Checked && (
                    <button
                      hidden={
                        !isParent1 ||
                        !SubModel.HearedParent1Editable ||
                        formLocked ||
                        SubModel.HearedParent1
                      }
                      style={{
                        borderRadius: "20px",
                        padding: "8px 20px",
                        backgroundColor: "#4377BA",
                        color: "white",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                      onClick={() =>
                        onSave(
                          "1",
                          Parent1Checked,
                          parent1ApprovalText,
                          generalPart.Parent2Name ? 2 : 1,
                        )
                      }
                    >
                      {Languages.SaveHearing}
                    </button>
                  )}
                </TableCell>

                <TableCell
                  sx={{ borderBottom: "none", pl: "20px" }}
                  align="left"
                >
                  {isParent2 && Parent2Checked && (
                    <button
                      hidden={
                        !isParent2 ||
                        !SubModel.HearedParent2Editable ||
                        formLocked ||
                        SubModel.HearedParent2
                      }
                      style={{
                        borderRadius: "20px",
                        padding: "8px 20px",
                        backgroundColor: "#4377BA",
                        color: "white",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                      onClick={() =>
                        onSave("2", Parent2Checked, parent2ApprovalText, 2)
                      }
                    >
                      {Languages.SaveHearing}
                    </button>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </AccordionDetails>
      </div>
    </Accordion>
  );
};

export default LeopsParentsHeard;
